/* Replace the old hours script in sections/microbakery-fridge.liquid with this script. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start(root.document, root);
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  var DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  var ENDPOINT = 'https://webhook.butterhalfseattle.com/api/hours';

  function to12(value) {
    if (typeof value !== 'string' || !/^([01]\d|2[0-3]):[0-5]\d$/.test(value)) {
      throw new Error('Invalid operating time');
    }
    var parts = value.split(':');
    var hour = Number(parts[0]);
    return (hour % 12 || 12) + ':' + parts[1] + (hour >= 12 ? ' PM' : ' AM');
  }

  function viewFor(data, now) {
    if (!data || !data.hours || typeof data.open_now !== 'boolean') {
      throw new Error('Hours unavailable');
    }
    var timezone = data.timezone || 'America/Los_Angeles';
    var today = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: timezone })
      .format(now || new Date()).toLowerCase();
    var weekly = [];
    DAYS.forEach(function (day) {
      var info = data.hours[day];
      if (!info || typeof info.closed !== 'boolean') throw new Error('Incomplete schedule');
      var opening = to12(info.open);
      var closing = to12(info.close);
      if (!info.closed) {
        if (info.open >= info.close) throw new Error('Invalid operating window');
        weekly.push(day[0].toUpperCase() + day.slice(1) + ': ' + opening + '–' + closing);
      }
    });
    var info = data.hours[today];
    var isOpen = data.open_now && !info.closed;
    var available = isOpen && (data.available === undefined || data.available === true);
    var timezoneLabel = timezone === 'America/Los_Angeles' ? 'Pacific time' : timezone;
    return {
      canOrder: available,
      heading: isOpen && !available ? 'Ordering is temporarily unavailable' : "We're getting ready!",
      message: isOpen && !available
        ? 'The fridge is temporarily unavailable. Please try again shortly or contact the bakery.'
        : info.closed ? 'The microbakery is closed today. See our current weekly hours below.'
          : 'Today’s hours: ' + to12(info.open) + '–' + to12(info.close) + ' (' + timezoneLabel + '), or until sold out.',
      schedule: weekly.length ? 'Weekly hours (' + timezoneLabel + '): ' + weekly.join('; ') + '. Closed on other days.'
        : 'The microbakery is closed this week. Please check back for updated hours.'
    };
  }

  function elements(document) {
    var closed = document.getElementById('mb-closed-msg');
    var grid = document.getElementById('mb-grid');
    if (!closed || !grid) return null;
    // The existing Shopify markup has no mb-hours-text ID. Use its real paragraph.
    var message = closed.querySelector('p');
    if (!message) { message = document.createElement('p'); closed.appendChild(message); }
    var weekly = document.getElementById('mb-weekly-hours');
    if (!weekly) {
      weekly = document.createElement('p');
      weekly.id = 'mb-weekly-hours';
      weekly.style.cssText = 'text-align:center;max-width:800px;margin:20px auto;padding:0 20px;line-height:1.6;';
      grid.parentNode.insertBefore(weekly, grid);
    }
    return { closed: closed, grid: grid, message: message, heading: closed.querySelector('h1'), weekly: weekly };
  }

  function render(document, view) {
    var nodes = elements(document);
    if (!nodes) return;
    nodes.grid.style.display = view.canOrder ? '' : 'none';
    nodes.closed.style.display = view.canOrder ? 'none' : 'block';
    nodes.message.textContent = view.message;
    nodes.weekly.textContent = view.schedule;
    if (nodes.heading) nodes.heading.textContent = view.heading;
  }

  function showFailure(document) {
    var nodes = elements(document);
    if (!nodes) return;
    nodes.grid.style.display = 'none';
    nodes.closed.style.display = 'block';
    if (nodes.heading) nodes.heading.textContent = 'Checking our opening hours';
    nodes.message.textContent = 'We cannot confirm fridge availability right now. Please try again shortly or contact the bakery.';
  }

  function start(document, window) {
    function mount() {
      var nodes = elements(document);
      if (!nodes || nodes.grid.dataset.hoursSync) return;
      nodes.grid.dataset.hoursSync = 'active';
      nodes.grid.style.display = 'none';
      nodes.closed.style.display = 'block';
      nodes.message.textContent = 'Checking our current opening hours…';
      nodes.weekly.textContent = '';
      var pending = false;
      var timer;
      function refresh() {
        if (pending) return;
        pending = true;
        window.clearTimeout(timer);
        var controller = new window.AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 5000);
        window.fetch(ENDPOINT, { cache: 'no-store', credentials: 'omit', signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Hours request failed');
            return response.json();
          })
          .then(function (data) { render(document, viewFor(data)); })
          .catch(function () { showFailure(document); })
          .finally(function () {
            window.clearTimeout(timeout);
            pending = false;
            timer = window.setTimeout(refresh, 15000);
          });
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
      refresh();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
    else mount();
    document.addEventListener('shopify:section:load', mount);
  }

  return { viewFor: viewFor, render: render, showFailure: showFailure, start: start };
});
